// Multi-location teams can span time zones. A location's IANA zone (null means
// "follow the team") decides the clock event times are typed and read on. With
// no location zone the forms use the team's own zone, which every team picks at
// activation and the server already steps repeats on. The browser's zone is only
// a last resort for pages without the team-time-zone meta tag.

// The current team's zone, from the layout's team-time-zone meta tag
export function teamTimeZone() {
  const meta = document.querySelector('meta[name=team-time-zone]');
  return (meta && meta.content) || null;
}

// Zone the event forms parse and display wall-clock times in
export function formTimeZone(locationTimeZone) {
  return locationTimeZone || teamTimeZone() || moment.tz.guess();
}

// Whether `zone`'s clock differs from the browser's at `at` (anything moment
// accepts; defaults to now). Compares offsets rather than names so e.g.
// America/Detroit in a New York browser doesn't count as different.
export function differsFromBrowser(zone, at) {
  if (!zone) {
    return false;
  }
  const when = at ? moment(at) : moment();
  return moment.tz(when, zone).utcOffset() !== when.clone().local().utcOffset();
}

// Whether two zones keep the same clock all year (e.g. America/Boise and
// America/Denver), checked in winter and summer so DST rules count
export function sameClock(a, b, at) {
  const year = (at ? moment(at) : moment()).year();
  return [0, 6].every((month) => {
    const when = moment.utc([year, month, 15]);
    return moment.tz(when, a).utcOffset() === moment.tz(when, b).utcOffset();
  });
}

// "Pacific Time", never "Pacific Daylight Time": coaches think in generic zones
// and a repeating series usually spans a DST change
export function zoneLabel(zone) {
  const option = TIME_ZONE_OPTIONS.find((o) => o.value === zone);
  if (option) {
    return option.label;
  }
  const part = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'longGeneric' })
    .formatToParts(new Date())
    .find((p) => p.type === 'timeZoneName');
  return part ? part.value : zone;
}

// Zones offered on the location form and the per-event picker. US-first since
// that's who we serve; anything else a record already carries is appended by
// the form so it's never silently dropped.
export const TIME_ZONE_OPTIONS = [
  { value: 'America/New_York', label: 'Eastern Time' },
  { value: 'America/Chicago', label: 'Central Time' },
  { value: 'America/Denver', label: 'Mountain Time' },
  { value: 'America/Phoenix', label: 'Mountain Time - Arizona (no DST)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time' },
  { value: 'America/Anchorage', label: 'Alaska Time' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time' },
  { value: 'America/Halifax', label: 'Atlantic Time' },
];
